import { Icon, Icons } from '@starrez/starryui';
import React, { useState } from 'react';
import { strings } from '../../localisation';
import { Button } from './Button';
import {
    OptionCaption,
    OptionCheckbox,
    OptionGhostButton,
    OptionHeader,
    OptionScroller,
    OptionSearch,
    OptionSeparator,
    SelectionOption,
} from '../../lists/SelectionOption';
import { ManagedDropdown } from '../../ManagedDropdown/ManagedDropdown';

export interface IManagedColumn {
    caption: string;
    visible: boolean;
    field: string;
}

export interface IManageColumnButtonProps {
    columns: IManagedColumn[];
    onClick: (col: IManagedColumn) => void;
    onResetColumns: () => void;
}

export const ManageColumnButton = ({ columns: cols, onResetColumns, onClick }: IManageColumnButtonProps) => {
    const [columns, setColumns] = useState(cols);
    const [search, setSearch] = useState<string>('');

    const handleSearch = (search: string) => {
        setSearch(search);
        return Promise.resolve();
    };

    const handleOnClick = (item: IManagedColumn) => {
        const found = columns.find((e) => e.caption === item.caption);
        if (found) {
            found.visible = !item.visible;
            setColumns([...columns]);
            onClick(item);
        }
    };

    const regex = RegExp(search, 'ig');

    const items = columns.sort((a, b) => a.caption?.localeCompare(b.caption as string) as number).filter((col) => col.caption?.match(regex));

    return (
        <ManagedDropdown
            width="250px"
            placement="bottom-end"
            onClose={() => setSearch('')}
            manager={(onClick, { visible }) => (
                <Button aria-haspopup="listbox" aria-pressed={visible} aria-expanded={visible} ariaLabel="" onClick={onClick} title="">
                    <Icon Icon={Icons.Column} />
                </Button>
            )}
        >
            <SelectionOption focusFirstElement selector="li > button, input[type='search']">
                <OptionHeader caption={strings.Manage_Columns} />
                <OptionSeparator />
                <OptionSearch onSearchChange={handleSearch} />
                <OptionScroller maxHeight="calc(100vh - 400px)">
                    {items.length ? (
                        items.map((e) => (
                            <OptionCheckbox
                                key={e.caption}
                                onClick={() => handleOnClick(e)}
                                highlight={search}
                                variant="control"
                                caption={e.caption}
                                checked={e.visible}
                            />
                        ))
                    ) : (
                        <OptionCaption caption="None Found" />
                    )}
                </OptionScroller>
                <OptionSeparator />
                <OptionGhostButton caption={strings.Action_ResetToDefault} onClick={onResetColumns} />
            </SelectionOption>
        </ManagedDropdown>
    );
};
